import { render, staticRenderFns } from "./real_name_pop.vue?vue&type=template&id=69fb2b48&scoped=true"
import script from "./real_name_pop.vue?vue&type=script&lang=js"
export * from "./real_name_pop.vue?vue&type=script&lang=js"
import style0 from "./real_name_pop.vue?vue&type=style&index=0&id=69fb2b48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fb2b48",
  null
  
)

export default component.exports